<div class="payer-configuration__header flex flex-row flex-wrap items-end justify-between gap-4">
  <div>
    <h1>Payer Configuration</h1>
    <p class="payer-configuration__subtitle">{{ subtitle() }}</p>
  </div>

  <button mat-flat-button class="primary-button-longtext"
    [matTooltip]="'Add Payer'"
    [matTooltipClass]="'app-tooltip'"
    (click)="onAddPayerClick()">+ Add Payer</button>
</div>

<!-- Row 1: the five list filters; row 2: the service year range and Reset. -->
<div class="payer-configuration__filters mat-elevation-z1">
  <app-payer-filter-select
    class="payer-configuration__filter"
    [form]="form"
    [queryOptions]="true"
    [includeInactive]="true"
    (ready)="isPayerReady = true; filtersReadyCheck();"
    (valueChanged)="onFilterChange()"></app-payer-filter-select>

  <app-filter-multi-select
    #configStatus
    class="payer-configuration__filter"
    [label]="'Status'"
    [options]="statusOptions"
    (valueChanged)="onFilterChange()"></app-filter-multi-select>

  <app-filter-multi-select
    #configRiskPolicy
    class="payer-configuration__filter"
    [label]="'Risk Adj. Policy'"
    [options]="yesNoOptions"
    (valueChanged)="onFilterChange()"></app-filter-multi-select>

  <app-filter-multi-select
    #configOmitPayer
    class="payer-configuration__filter"
    [label]="'Omit Payer'"
    [options]="yesNoOptions"
    (valueChanged)="onFilterChange()"></app-filter-multi-select>

  <app-filter-multi-select
    #configPreferredAction
    class="payer-configuration__filter"
    [label]="'Preferred Action'"
    [options]="preferredActionOptions()"
    (valueChanged)="onFilterChange()"></app-filter-multi-select>

  <app-year-range-filter
    class="payer-configuration__year-range"
    [fromLabel]="'Service Year From'"
    [toLabel]="'Service Year To'"
    [minYear]="2021"
    [maxYearAddition]="2"
    (valueChanged)="onFilterChange()"></app-year-range-filter>

  <button mat-button class="payer-configuration__reset"
    [matTooltip]="'Reset filters to the defaults'"
    [matTooltipClass]="'app-tooltip'"
    (click)="onResetClick()">
    <mat-icon>restart_alt</mat-icon> Reset
  </button>
</div>

<div class="payer-configuration__toolbar flex flex-row flex-wrap items-center justify-between gap-3">
  <span class="payer-configuration__hint">Click a payer to view its service year policies</span>
  <div class="flex flex-row gap-1">
    <button mat-button (click)="onExpandAllClick()"><mat-icon>unfold_more</mat-icon> Expand All</button>
    <button mat-button (click)="onCollapseAllClick()"><mat-icon>unfold_less</mat-icon> Collapse All</button>
  </div>
</div>

<div class="payer-configuration__grid flex flex-auto">
  <ag-grid-angular
    class="ag-theme-balham w-full h-full"
    [rowData]="store.groups()"
    [loading]="store.loading()"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [getRowId]="getRowId"
    [pagination]="true"
    [suppressPaginationPanel]="true"
    [statusBar]="statusBar"
    [context]="gridContext"
    [noRowsOverlayComponent]="noRowsOverlayComponent"
    [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
    [loadingOverlayComponent]="loadingOverlayComponent"
    [getContextMenuItems]="getContextMenuItems"
    (gridReady)="onGridReady()"
    (rowDataUpdated)="onRowDataUpdated()"
    (rowClicked)="onRowClicked($event)"
    (cellKeyDown)="onCellKeyDown($event)"></ag-grid-angular>
</div>
